// List of possible family relationship options for dropdowns
// Update this list as needed for new relationships

const relationshipOptions = [
  'Parent',
  'Child',
  'Sibling',
  'Half-Sibling',
  'Grandparent',
  'Grandchild',
  'Great-Grandparent',
  'Great-Grandchild',
  'Great-Great-Grandparent',
  'Great-Great-Grandchild',
  'Great-Great-Great-Grandparent',
  'Great-Great-Great-Grandchild',
  'Great-Great-Great-Great-Grandparent',
  'Great-Great-Great-Great-Grandchild',
  'Aunt',
  'Uncle',
  'Niece',
  'Nephew',
  'Cousin',
  'Second Cousin',
  'Third Cousin',
  'Fourth Cousin',
  'Fifth Cousin',
  'Sixth Cousin',
  'Seventh Cousin',
  'Eighth Cousin',
  'Ninth Cousin',
  'Second Cousin once removed',
  'Third Cousin once removed',
  'Fourth Cousin once removed',
  'Fifth Cousin once removed',
  'Sixth Cousin once removed',
  'Seventh Cousin once removed',
  'Eighth Cousin once removed',
  'Half-Aunt',
  'Half-Uncle',
  'Half-Niece',
  'Half-Nephew',
  'Step-Parent',
  'Step-Child',
  'Step-Sibling',
  'Step-Grandparent',
  'Step-Grandchild',
  'Spouse',
  'Partner',
  'Fiancé',
  'Ex-Spouse',
  'Ex-Partner',
  'In-law',
  'Father-in-law',
  'Mother-in-law',
  'Son-in-law',
  'Daughter-in-law',
  'Brother-in-law',
  'Sister-in-law',
  'Other',
];

export default relationshipOptions; 